import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Http, Response, Headers, RequestOptions } from '@angular/http';


@Injectable()
export class BaseService {
  protected headers: Headers;

  constructor(
    protected http: Http
  ) {
    this.headers = new Headers;
  }
  get getHttp() {
    return this.http;
  }

  setAuthorizationHeaders() {
    this.headers.append(environment.server.api_key.header, environment.server.api_key.value);
  }

  get getHeaders(): Headers {
    return this.headers;
  }
}


// WEBPACK FOOTER //
// /Users/jaswantsingh/Documents/GitHub/maps/src/app/core/services/base-service.ts